// Feature Showcase Section JavaScript
class FeatureShowcaseSection {
  constructor(container) {
    this.container = container;
    this.tabs = this.container.querySelectorAll('.feature-showcase-tab-button');
    this.contents = this.container.querySelectorAll('.feature-showcase-tab-content');

    if (!this.tabs.length) return;

    this.initTabs();
  }

  initTabs() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        this.activateTab(tab);
      });

      // Support keyboard navigation
      tab.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.activateTab(tab);
          }
          // Optional: Add ArrowLeft/ArrowRight support later if needed
      });

    });

    // Ensure initial state is correct on load
     const initialActiveTab = this.container.querySelector('.feature-showcase-tab-button.is-active');
     if (initialActiveTab) {
       this.activateTab(initialActiveTab, false); // Don't refocus on initial load
     } else if(this.tabs.length > 0) {
       // Fallback if no tab is marked active initially
       this.activateTab(this.tabs[0], false);
     }
  }

  activateTab(activeTab, setFocus = true) {
    const targetContentId = activeTab.getAttribute('data-tab-target');
    const targetContent = this.container.querySelector(targetContentId);

    // Deactivate all tabs and hide all content
    this.tabs.forEach(tab => {
      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1'); // Make inactive tabs not easily focusable
    });
    this.contents.forEach(content => {
      content.classList.remove('is-active');
      content.hidden = true;
    });

    // Activate the clicked tab and show its content
    activeTab.classList.add('is-active');
    activeTab.setAttribute('aria-selected', 'true');
    activeTab.setAttribute('tabindex', '0'); // Make active tab focusable

    if (targetContent) {
      targetContent.classList.add('is-active');
      targetContent.hidden = false;
    }

    if (setFocus) {
      activeTab.focus();
    }
  }
}

// Initialize sections on page load and theme editor updates
function initializeFeatureShowcaseSections() {
  document.querySelectorAll('[data-section-id].feature-showcase-section').forEach(sectionElement => {
    // Avoid re-initializing if already done
    if (!sectionElement.featureShowcaseInstance) {
      sectionElement.featureShowcaseInstance = new FeatureShowcaseSection(sectionElement);
    }
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', initializeFeatureShowcaseSections);

// Theme editor load/select events
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
     if (event.target.classList.contains('shopify-section-feature-showcase')) {
        // Ensure the element exists before trying to init
        const sectionElement = event.target.querySelector('.feature-showcase-section');
        if (sectionElement) {
          sectionElement.featureShowcaseInstance = new FeatureShowcaseSection(sectionElement);
        }
     }
  });
   // Re-init on select/deselect might be needed depending on theme structure, but load usually covers it.
   // document.addEventListener('shopify:section:select', ...);
   // document.addEventListener('shopify:section:deselect', ...);
   // document.addEventListener('shopify:block:select', ...);
   // document.addEventListener('shopify:block:deselect', ...);
}

// Also run initialization when Turbolinks/Turbo loads content (if theme uses it)
document.addEventListener('turbo:load', initializeFeatureShowcaseSections); 